import api from './api'

/**
 * Service for interacting with the search analytics system
 */
export const searchAnalyticsService = {
  /**
   * Fetches term suggestions when the search returns no results
   * @param {string} term - Search term that returned no results
   * @param {number} limit - Maximum number of suggestions (default: 5)
   * @returns {Promise<Object>} Object with suggestions
   */
  async getSuggestions(term, limit = 5) {
    try {
      const response = await api.get('/search-analytics/suggestions', {
        params: { term, limit }
      })
      return response.data
    } catch (error) {
      console.error('Erro ao buscar sugestões de busca:', error)
      return {
        original_term: term,
        suggestions: [],
        message: 'Nenhum resultado encontrado.'
      }
    }
  },

  /**
   * Fetches the most popular terms
   * @param {number} limit - Maximum number of terms (default: 10)
   * @returns {Promise<Array>} List of popular terms
   */
  async getPopularTerms(limit = 10) {
    try {
      const response = await api.get('/search-analytics/popular', {
        params: { limit }
      })
      return response.data
    } catch (error) {
      console.error('Erro ao buscar termos populares:', error)
      return []
    }
  }
}

export default searchAnalyticsService

